"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListPartsInput_1 = require("./ListPartsInput");
var ListPartsOutput_1 = require("./ListPartsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListParts = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListParts",
    http: {
        method: "GET",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: ListPartsInput_1.ListPartsInput
    },
    output: {
        shape: ListPartsOutput_1.ListPartsOutput
    },
    errors: []
};
//# sourceMappingURL=ListParts.js.map